import { render } from "./PsInput.vue?vue&type=template&id=821c52f8&ts=true"
import script from "./PsInput.vue?vue&type=script&lang=ts"
export * from "./PsInput.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__